import { useCallback, useState } from 'react';
import { supabase } from '../supabaseClient';

export function useSupabaseThoughts() {
    const [thoughts, setThoughts] = useState([]);

    const fetchThoughts = useCallback(async () => {
        const { data, error } = await supabase.from('thoughts').select('*');
        if (error) {
            console.error('Error fetching thoughts:', error);
        } else {
            setThoughts(data || []);
        }
    }, []);

    const addThought = useCallback(async (thought) => {
        const { data, error } = await supabase.from('thoughts').insert([thought]).select();
        if (error) {
            alert('Error saving thought: ' + error.message);
            return;
        }
        setThoughts((prev) => [...prev, ...(data || [])]);
    }, []);

    const updateThoughtPosition = useCallback(async (id, x, y) => {
        const { error } = await supabase
            .from('thoughts')
            .update({ x, y })
            .eq('id', id);

        if (error) {
            console.error('Error updating position:', error);
        }
    }, []);

    const deleteThought = useCallback(async (id) => {
        const { error } = await supabase.from('thoughts').delete().eq('id', id);
        if (error) {
            alert('Error deleting: ' + error.message);
        } else {
            setThoughts((prev) => prev.filter((t) => t.id !== id));
        }
    }, []);

    return {
        thoughts,
        setThoughts,
        fetchThoughts,
        addThought,
        updateThoughtPosition,
        deleteThought
    };
}